module.exports = __webpack_public_path__ + "static/media/paredes_vivas_7.c1346258.jpg";